export const SET_FILTER = 'FILTER/SET';



// WEBPACK FOOTER //
// ./src/filter/actionTypes.js